import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const PageContent = ({ children, className }) => {
    const contentClassses = cx('page__content', {
        [className]: className,
    });
    return <div className={contentClassses}>{children}</div>;
};

PageContent.propTypes = {
    children: PropTypes.any,
};

export default PageContent;
